import { getTextDepth } from './getTextDepth';
import { getTextInnerGlow } from './getTextInnerGlow';
import type { TextElement } from '../../types';

// Effects use the same SVG fill path as gradients and borders. Normalize the
// persisted alignment together with the effect edit, in one Undo step.
export function getTextEffectAlignmentUpdate(
  element: Pick<TextElement, 'textAlign' | 'textDepth' | 'textInnerGlow'>
) {
  return element.textAlign === 'justify' &&
    (getTextDepth(element.textDepth) || getTextInnerGlow(element.textInnerGlow))
    ? { textAlign: 'left' as const }
    : {};
}
